export const MESSAGES_SET = "MESSAGES_SET";
export const MESSAGE_SET = "MESSAGE_SET";
export const MESSAGE_RETRY = "MESSAGE_RETRY";
export const MESSAGE_CANCEL = "MESSAGE_CANCEL";
